import React from 'react';

import { HostedSessionOutcome } from '../HostedSessionOutcome';
import InitializeSessionData from '../../shared/CheckoutSessionInitializer/InitializeSessionData';

import { SharedEmbeddedHostedRouter } from './SharedEmbeddedHostedRouter';

/**
 * Derive url from session data, pass url to `<MemoryRouter`
 */
const SessionRouter = () => {
  return (
    <InitializeSessionData>
      <HostedSessionOutcome>
        <SharedEmbeddedHostedRouter />
      </HostedSessionOutcome>
    </InitializeSessionData>
  );
};

export default SessionRouter;
